import { ActionIcon, Text } from "@mantine/core"
import { IconEye } from "@tabler/icons-react"
import { BaseSyntheticEvent, ReactNode, useState } from "react"

import { httpClient } from "~/backend/axios"

type Props = {
  documentId: string
  showAsText?: boolean
  customText?: string
  documentIcon?: ReactNode
}
export function DocumentView({
  documentId,
  showAsText,
  customText,
  documentIcon,
}: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const [url, setUrl] = useState<string>()

  const handleViewDocument = async (e: BaseSyntheticEvent) => {
    e.stopPropagation()
    if (!url) {
      setIsLoading(true)
      const response = await httpClient.get(`/documents/${documentId}`)
      setUrl(response.data.url)
      setIsLoading(false)
      return window.open(response.data.url, "_blank")
    } else {
      window.open(url, "_blank")
    }
  }

  return showAsText ? (
    <Text fz="sm" onClick={handleViewDocument}>
      {customText ? customText : "View"}
    </Text>
  ) : (
    <ActionIcon
      onClick={handleViewDocument}
      loading={isLoading}
      variant="transparent"
      color="gray"
    >
      {documentIcon ?? <IconEye />}
    </ActionIcon>
  )
}
